<template>
  <div>
    <shipblu-prompt
      class="shipment-modal"
      @close="closeModal()"
      :active.sync="updateModal"
      :title="$t('New Announcement')"
      :buttons-hidden="true"
    >
      <div class="flex flex-col gap-4">
        <div>
          <shipblu-input v-validate="'required'" name="announcement date" :labelPlaceholder="$t('Announcement Date')" :required="true" v-model="update.date" type="date"/>
          <span class="text-danger text-sm" v-show="errors.has('announcement date')">{{ errors.first('announcement date') }}</span>
        </div>

        <div>
          <shipblu-input v-validate="'required'" name="announcement text arabic" :labelPlaceholder="$t('Announcement Text Arabic')" :required="true" autocomplete="nofill" v-model="update.ar_text" type="text"/>
          <span class="text-danger text-sm" v-show="errors.has('announcement text arabic')">{{ errors.first('announcement text arabic') }}</span>
        </div>

        <div>
          <shipblu-input v-validate="'required'" name="announcement text english" :labelPlaceholder="$t('Announcement Text English')" :required="true"  autocomplete="nofill" v-model="update.en_text" type="text"/>
          <span class="text-danger text-sm" v-show="errors.has('announcement text english')">{{ errors.first('announcement text english') }}</span>
        </div>

        <div>
          <shipblu-input v-validate="update.en_link_text || update.link_url ? 'required' : ''" name="announcement link text arabic" :labelPlaceholder="$t('Announcement Link Text Arabic')" :required="!!update.en_link_text || !!update.link_url" autocomplete="nofill" v-model="update.ar_link_text" type="text"/>
          <span class="text-danger text-sm" v-show="errors.has('announcement link text arabic')">{{ errors.first('announcement link text arabic') }}</span>
        </div>

        <div>
          <shipblu-input v-validate="update.ar_link_text || update.link_url ? 'required' : ''" name="announcement link text english" :labelPlaceholder="$t('Announcement Link Text English')" :required="!!update.ar_link_text || !!update.link_url" autocomplete="nofill" v-model="update.en_link_text" type="text"/>
          <span class="text-danger text-sm" v-show="errors.has('announcement link text english')">{{ errors.first('announcement link text english') }}</span>
        </div>

        <div>
          <shipblu-input v-validate="update.ar_link_text || update.en_link_text ? 'required|url:require_protocol' : ''" name="announcement link" :labelPlaceholder="$t('Announcement Link')" :required="!!update.ar_link_text || !!update.en_link_text" autocomplete="nofill" v-model="update.link_url" type="text"/>
          <span class="text-danger text-sm" v-show="errors.has('announcement link')">{{ errors.first('announcement link') }}</span>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-4">
        <button @click="closeModal" class="btn disable-btn">{{ $t('Close') }}</button>
        <button @click="addNewUpdate()" class="active-btn btn">{{ $t('Add') }}</button>
      </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import ShipbluPrompt from '../../layouts/components/ShipBluPrompt.vue'
import {sendRequest} from '../../http/axios/requestHelper.js'
import i18nData from '../../i18n/i18nData.js'
import Datepicker from 'vuejs-datepicker'

export default {
  props:['updateModal'],
  data () {
    return {
      update: {
        date: new Date().toISOString().split('T')[0]
      }
    }
  },
  methods: {
    addNewUpdate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.update.link_url = this.update.link_url ? !this.update.link_url.startsWith('http://') && !this.update.link_url.startsWith('https://') ? `http://${this.update.link_url}` : this.update.link_url : ''
          sendRequest(false, false, this, 'api/v1/announcements/', 'post', this.update, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Announcement'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              this.$emit('updateModal', false)
              this.$emit('loadUpdates')
              this.update = {}
            },
          )
        }
      })
    },
    closeModal () {
      this.update = {
        date: new Date().toISOString().split('T')[0]
      }
      this.$emit('updateModal', false)
    }
  },
  components: {
    ShipbluPrompt,
    Datepicker
  }
}
</script>
